export default __webpack_public_path__ + "static/media/photo--sm--leena-2.5b8df78b.jpg";